import classNames from 'classnames'

import type { ArticlePreviewCardProps } from '~/components/atoms/ArticlePreviewCard/ArticlePreviewCard'
import ArticlePreviewCard from '~/components/atoms/ArticlePreviewCard/ArticlePreviewCard'
import Container from '~/components/atoms/Container/Container'
import Ctas from '~/components/atoms/Ctas/Ctas'
import Fixture from '~/components/atoms/Fixture/Fixture'
import type { TextProps } from '~/components/atoms/Text/Text'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { ComponentTheme } from '~/components/themes'

import RelatedArticles from '../RelatedArticles/RelatedArticles'

import styles from './HighlightArticles.module.css'

export enum HighlightArticlesVariants {
  default = 'default',
  slider = 'slider',
}

export interface HighlightArticlesProps {
  highlightArticles: ArticlePreviewCardProps[]
  theme?: ComponentTheme
  verticalPadding?: boolean
  noPaddingBottom?: boolean
  testID?: string
  moduleId?: string
  titleTag?: TextProps['Tag']
  title?: string
  hightlightBody?: string
  ctas?: any
  highlightVariant?: HighlightArticlesVariants
}

export default function HighlightArticles({
  highlightArticles,
  theme,
  verticalPadding,
  noPaddingBottom,
  testID,
  moduleId,
  titleTag = 'h3',
  highlightVariant = HighlightArticlesVariants.default,
  title,
  hightlightBody,
  ctas,
}: HighlightArticlesProps) {
  return (
    <Fixture
      theme={theme}
      verticalPadding={verticalPadding}
      noPaddingBottom={noPaddingBottom}
      id={moduleId}
    >
      <div
        className={classNames(
          highlightVariant === HighlightArticlesVariants.default && styles.base,
          (title || hightlightBody || ctas) && styles.topPadding
        )}
        data-testid={testID}
      >
        {title && (
          <Container>
            <Text size={TextSizes.primaryTitleLrg} className={styles.title}>
              {title}
            </Text>
          </Container>
        )}
        {hightlightBody && (
          <>
            <Container>
              <Text
                size={TextSizes.secondaryTitleMedReg}
                className={classNames(
                  styles.body,
                  title && styles.bodyWithMargin
                )}
              >
                {hightlightBody}
              </Text>
            </Container>
          </>
        )}
        {ctas && (
          <Container>
            <div className={styles.ctas}>
              <Ctas ctas={ctas} theme={ComponentTheme.black} />
            </div>
          </Container>
        )}
        {highlightVariant === HighlightArticlesVariants.default ? (
          <>
            {highlightArticles &&
              highlightArticles.map(
                (item: ArticlePreviewCardProps, i: number) => {
                  return (
                    <ArticlePreviewCard
                      {...item}
                      title={`${item.title}`}
                      category="Guide"
                      modules={item.modules}
                      summaryLimit={200}
                      variant={highlightArticles.length > 1 ? `large` : 'huge'}
                      leadImage={item.leadImage}
                      listPreviewImage={item?.listPreviewImage}
                      key={`related-articles-${i}`}
                      titleTag={titleTag}
                      sizes="(max-width: 559px) 100vw, 50vw"
                      sansTitle={true}
                    />
                  )
                }
              )}
          </>
        ) : (
          <RelatedArticles
            theme={ComponentTheme.magazine}
            baseTheme={ComponentTheme.primary}
            hideTitle
            hideArrows
            articles={highlightArticles}
          />
        )}
      </div>
    </Fixture>
  )
}
